<template>
  <div class="play" @click="onclick">
    <span
      id="start"
      :class="{start: !isPlaying, stop: isPlaying}"
      ></span>
      <span class="play-bottom">再生/停止</span>
  </div>
</template>

<script>
export default {
  name: 'play',
  props: {
    isPlaying: {type: Boolean, required: true}
  },
  methods: {
    onclick(){
      if (this.isPlaying) {
        this.$emit('stop');
      } else {
        this.$emit('start');
      }
    }
  }
}
</script>

<style scoped>
.play{
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
}
#start{
  position: relative;
  display: block;
  margin: 15px auto 8px;
  width: 24px;
  height: 24px;
}
#start::before,
#start::after{
  position: absolute;
  display: block;
  content: '';
  top: 0;
  transition: 0.3s;
}
.start::before{
  left: 0;
  height: 24px;
  width: 4px;
  background-color: #333;
}
.start::after,
.stop::after{
  left: 6px;
  height: 0;
  width: 0;
  border-style: solid;
  border-width: 12px 0 12px 18px;
  border-color: transparent transparent transparent #333;
}
.stop::before{
  left: 0;
  height: 24px;
  width: 24px;
  background-color: #333;
}

span:last-child{
  color: #333;
  font-size: 0.65rem;
}
</style>
